// shabba-dashboard/src/utils/parseFix.ts

export function toNum(n?: string) {
  const x = Number(n);
  return Number.isFinite(x) ? x : undefined;
}
export function toInt(n?: string) {
  const x = parseInt(n ?? "", 10);
  return Number.isFinite(x) ? x : undefined;
}

export function parseFixMessage(raw: string): any {
  try {
    const fields = raw.split("|").filter(Boolean);
    const result: any = {};
    const kv: Array<[string, string]> = [];

    for (const f of fields) {
      const i = f.indexOf("=");
      if (i === -1) continue;
      kv.push([f.slice(0, i), f.slice(i + 1)]);
    }

    for (const [tag, val] of kv) {
      if (tag !== "269" && tag !== "270" && tag !== "271") {
        result[tag] = val;
      }
    }

    const entries: any[] = [];
    let i = kv.findIndex(([t]) => t === "268");
    if (i < 0) i = 0; else i = i + 1;

    while (i < kv.length) {
      const [tag, value] = kv[i];
      if (tag === "269") {
        const entry: any = { type: value };
        i++;
        while (i < kv.length && kv[i][0] !== "269") {
          const [t, v] = kv[i];
          switch (t) {
            case "270": entry.price = toNum(v); break;
            case "271": entry.size = toInt(v); break;
            case "278": entry.id = v; break;
            case "279": entry.action = v; break;
            case "273": entry.time = v; break;
            case "1023": entry.level = toInt(v); break;
            case "288":
            case "289": entry.mm = v; break;
          }
          i++;
        }
        entries.push(entry);
      } else {
        i++;
      }
    }

    if (entries.length) result.entries = entries;
    return result;
  } catch {
    return { error: "Failed to parse", raw };
  }
}
